import React from 'react'
import { Chatbubble } from '@dsny/dsny-component-library/icons'
import { useTheme } from 'styled-components'

const ChatButton = ({ style }) => {
  const openChatWindow = () => {
    $zoho.salesiq.floatwindow.visible('show')
  }
  const theme = useTheme()

  return (
    <button
      type="button"
      className="w-8 h-8 focus:outline-none"
      onClick={openChatWindow}
      style={{
        width: 18,
        color: theme.colors.neutralW90,
        ...style
      }}
    >
      <Chatbubble className="w-full" />
    </button>
  )
}

export default ChatButton
